import script from "./FixtureOrderSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./FixtureOrderSelector.vue?vue&type=script&setup=true&lang=js"

import "./FixtureOrderSelector.vue?vue&type=style&index=0&id=36c81baa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c81baa"]])

export default __exports__